import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import React from 'react';
import Accounts from './Accounts';
import { useTranslation } from '../../hooks/useTranslation';

const TrackedAccounts = ({ customDetails, trackedAccounts }) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<Box
			display="flex"
			flexDirection="column"
			padding={isMobile ? '16px 20px 20px 20px' : '16px 30px 20px 30px'}
			sx={{ fontFamily: customDetails?.fontFamily }}
		>
			<Box sx={{ marginBottom: '14px' }}>
				<Typography
					variant="h6"
					sx={{
						textAlign: 'left',
						fontSize: isMobile ? '0.75rem' : '0.875rem',
						fontWeight: 600,
						fontFamily: customDetails?.fontFamily,
					}}
				>
					{t('consentRenewal.labels.trackedAccounts')}
				</Typography>
			</Box>
			<Box>
				{trackedAccounts &&
					trackedAccounts.map((account) => (
						<Accounts
							key={account.linkRefNumber}
							account={account}
							customDetails={customDetails}
						/>
					))}
			</Box>
		</Box>
	);
};

export default TrackedAccounts;
